import {
  SET_DEFAULT_STATE_SERVICE,
  SET_TYPE_SERVICE,
  UPDATE_SERVICE_NAME,
  BLUR_INPUT_SERVICE_NAME,
  //ready apps
  SET_READY_APPS_LIST,
  SELECT_READY_APPS,
  SET_READY_APP_SELECTED_VERSION,
  SET_USER_DB_LIST,
  SET_USER_DB_SELECTED,
  //custom apps
  SET_CUSTOM_APPS_LIST,
  SELECT_CUSTOM_APPS,
  SET_CUSTOM_APP_SELECTED_VERSION,
  //databases
  SET_DATABASE_LIST,
  SELECT_DATABASE,
  SET_DATABASE_SELECTED_VERSION
} from "../mutation-types";

export default {
  [SET_DEFAULT_STATE_SERVICE]: ({ commit }) => {
    commit(SET_DEFAULT_STATE_SERVICE);
  },
  [SET_TYPE_SERVICE]: ({ commit }, type) => {
    commit(SET_TYPE_SERVICE, type);
  },
  [UPDATE_SERVICE_NAME]: ({ commit }, serviceName) => {
    commit(UPDATE_SERVICE_NAME, serviceName);
  },
  [BLUR_INPUT_SERVICE_NAME]: ({ commit }, serviceName) => {
    commit(BLUR_INPUT_SERVICE_NAME, serviceName);
  },
  /***************Ready Aplication***************/
  [SET_READY_APPS_LIST]: ({ commit }) => {
    commit(SET_READY_APPS_LIST);
  },
  [SELECT_READY_APPS]: ({ commit }, id) => {
    commit(SELECT_READY_APPS, id);
  },
  [SET_READY_APP_SELECTED_VERSION]: ({ commit }, version) => {
    commit(SET_READY_APP_SELECTED_VERSION, version);
  },
  [SET_USER_DB_LIST]: ({ commit }) => {
    commit(SET_USER_DB_LIST);
  },
  [SET_USER_DB_SELECTED]: ({ commit }, databaseID) => {
    commit(SET_USER_DB_SELECTED, databaseID);
  },
  /***************Custom Aplication***************/
  [SET_CUSTOM_APPS_LIST]: ({ commit }) => {
    commit(SET_CUSTOM_APPS_LIST);
  },
  [SELECT_CUSTOM_APPS]: ({ commit }, id) => {
    commit(SELECT_CUSTOM_APPS, id);
  },
  [SET_CUSTOM_APP_SELECTED_VERSION]: ({ commit }, version) => {
    commit(SET_CUSTOM_APP_SELECTED_VERSION, version);
  },
  /***************Database***************/
  [SET_DATABASE_LIST]: ({ commit }) => {
    commit(SET_DATABASE_LIST);
  },
  [SELECT_DATABASE]: ({ commit }, id) => {
    commit(SELECT_DATABASE, id);
  },
  [SET_DATABASE_SELECTED_VERSION]: ({ commit }, version) => {
    commit(SET_DATABASE_SELECTED_VERSION, version);
  }
};
